import {ValueObject} from '@s-ui/domain'

export class GetRemoteUrlRequest extends ValueObject {
  /**
   * @param {Object} param
   * @param {Array} param.items
   */

  static validate({items = [], invalidRemoteRequestError}) {
    const [{data: {uniqueVehicleId}, urlType} = {}] = items

    if (urlType === 'TechnicalData' && !uniqueVehicleId) throw invalidRemoteRequestError('uniqueVehicleId is required')
  }

  getItems = () => this._items
}
